import classNames from 'classnames';
import { ComponentProps } from 'react';

import Emoji from './Emoji';
import CrossIcon from './icons/CrossIcon';

type ChipOwnProps = {
  emoji?: string | null,
  shiftName: string,
  isSelected?: boolean,
  isRemovable?: boolean,
  onRemove?: () => void,
  className?: string,
};
type ChipProps = ChipOwnProps & Omit<ComponentProps<'div'>, keyof ChipOwnProps>;

const Chip = ({
  emoji,
  shiftName,
  isSelected = false,
  isRemovable = false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onRemove = () => {},
  className = '',
  ...rest
}: ChipProps) => (
  <div
    className={
      classNames(
        'inline-flex h-10 font-medium min-w-fit items-center gap-[6px] p-1 pr-2 text-secondary-600 !rounded-2xl shadow-down-xs',
        { 'bg-white hover:bg-secondary-100': !isSelected },
        { 'bg-primary-100 outline outline-1 outline-offset-[-1px] outline-primary-400 hover:bg-primary-50': isSelected },
        className,
      )
    }
    {...rest}
  >
    <Emoji
      className={
        classNames(
        "size-8 rounded-lg bg-secondary-50",
        { 'bg-secondary-50-transparent': isSelected },
      )}
      emoji={emoji}
    />
    <span>{shiftName}</span>
    {isSelected
    && (
      <button type="button" className="p-0" aria-label="remove button" onClick={() => onRemove()}>
        <CrossIcon className="w-4" />
      </button>
    )}
  </div>
);

export default Chip;
